import React, { useContext, useState, useEffect } from "react";
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail, 
  onAuthStateChanged,
  sendEmailVerification
} from "firebase/auth";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { auth, db } from "../firebase";
import { doc, setDoc, getDoc, serverTimestamp } from "firebase/firestore";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState();
  const [loading, setLoading] = useState(true);

  async function signup(email, password, userData = {}) {
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Store additional user data in Firestore in students collection
      await setDoc(doc(db, "students", user.uid), {
        email: user.email,
        uid: user.uid,
        ...userData,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      });

      return userCredential;
    } catch (error) {
      throw error;
    }
  }

  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  }

  // Google authentication removed as per requirements

  function logout() {
    return signOut(auth);
  }
  
  function emailVerification() {
    return sendEmailVerification(currentUser);
  }

  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email);
  }
  
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      setCurrentUser(user);
      setLoading(false);
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    signup,
    login,
    logout,
    resetPassword,
    emailVerification
  };

  return (
    <AuthContext.Provider value={value}>
      {loading ? 
        <Box sx={{ display: 'block', textAlign: 'center', marginTop: '49vh' }}>
          <CircularProgress />
        </Box> 
        : 
        children
      }
    </AuthContext.Provider>
  );
}